<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.ownerId">
    <CommonConfig slot-scope="{data}" :order-type-prop="data.orderType" :status-prop="data.status" :owner-type-prop="data.ownerType" :owner-id-prop="data.ownerId" :is-config-detail="true"></CommonConfig>
  </l-cache>
</template>
<script>
import CommonConfig from './commonConfig'
import LCache from '../../../../ladmin/components/LCache/LCache'
export default {
  components: {LCache, CommonConfig},
  methods: {
    async getItem (key) {
      let data = {
        ownerId: this.$route.query.ownerId,
        orderType: this.$route.query.orderType,
        status:this.$route.query.status,
        ownerType:this.$route.query.ownerType
      }
      return data
    }
  }
}
</script>
